// Status vocab for Sales Enquiry/Installation/Guard Deployment Line -
// passed as classMap/labelMap overrides into the shared
// components/common/StatusBadge. Order itself has no single status column
// (legacy scattered-flags model, deliberately not collapsed into one enum)
// - display Open/Closed from isClosed plus separate small indicator chips.
export const ENQUIRY_STATUS_CLASS = {
  SUBMITTED: "badge-linewarning",
  APPROVED: "badge-lineinfo",
  CONFIRMED: "badge-linesuccess",
  REJECTED: "badge-linedanger",
  POSTPONED: "badge-linesecondary",
  LOST: "badge-linedanger",
};
export const ENQUIRY_STATUS_LABEL = {
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  CONFIRMED: "Confirmed",
  REJECTED: "Rejected",
  POSTPONED: "Postponed",
  LOST: "Lost",
};

// An order is Open, Closed (delivered and invoiced) or Cancelled (Batch162).
// A cancelled order is ALSO isClosed on the wire, so isCancelled must be
// tested first - "isClosed" alone no longer means invoiced.
export const orderStatus = (order) => {
  if (!order) return null;
  if (order.isCancelled) return { label: "Cancelled", cls: "badge-linesecondary" };
  if (order.isClosed) return { label: "Closed", cls: "badge-linedanger" };
  return { label: "Open", cls: "badge-linesuccess" };
};

export const INSTALLATION_STATUS_CLASS = {
  SCHEDULED: "badge-linewarning",
  IN_PROGRESS: "badge-lineinfo",
  ON_HOLD: "badge-linedanger",
  COMPLETED: "badge-linesuccess",
};
export const INSTALLATION_STATUS_LABEL = {
  SCHEDULED: "Scheduled",
  IN_PROGRESS: "In Progress",
  ON_HOLD: "On Hold",
  COMPLETED: "Completed",
};

export const DEPLOYMENT_LINE_STATUS_CLASS = {
  PENDING: "badge-linewarning",
  PARTIAL: "badge-lineinfo",
  DEPLOYED: "badge-linesuccess",
};
export const DEPLOYMENT_LINE_STATUS_LABEL = {
  PENDING: "Pending",
  PARTIAL: "Partial",
  DEPLOYED: "Deployed",
};

export const SERVICE_KIND_BADGE = {
  GUARDS: { cls: "badge-linesuccess", label: "Guards" },
  ALARMS: { cls: "badge-lineinfo", label: "Alarms" },
  OTHER: { cls: "badge-linewarning", label: "Other" },
};

// Mirrors SalesService.QualifiesForSelfApproval / quotation_pdf_builder.dart's
// _isGuardsAndAlarmsOnly exactly: non-empty selection, every type is
// GUARDS/ALARMS-kind, and the branch isn't Systems (Systems never carries a
// GUARDS/ALARMS-kind row at all, but this is checked explicitly too so the
// UI doesn't depend solely on seed data staying that way).
export const SYSTEMS_BRANCH_CODE = "SYSTEMS";

export const qualifiesForRateBasedApproval = (serviceTypes, branchCode) =>
  Boolean(
    serviceTypes &&
      serviceTypes.length > 0 &&
      branchCode !== SYSTEMS_BRANCH_CODE &&
      serviceTypes.every((s) => s.serviceKind === "GUARDS" || s.serviceKind === "ALARMS")
  );

// Separate, deliberately more permissive helper for the quotation PDF's
// layout choice only - NOT for approval-permission gating (that must stay
// exactly qualifiesForRateBasedApproval, matching SalesService.
// QualifiesForSelfApproval's own serviceTypes.Count > 0 requirement, or the
// Approve form would show the wrong shape/fields). An enquiry created
// before the branch-wise Service Type rework (Batch63, 2026-08-19, e.g.
// SE-000001) has zero rows here even though it's genuinely a Guards/Alarms
// enquiry with real priced amounts - the PDF layout has no server-side
// consequence at all (100% client-rendered), so for that legacy case fall
// back to the underlying amounts instead of the now-empty service list.
export const qualifiesForGuardsAlarmsLayout = (enquiry, serviceTypes) => {
  if (enquiry?.branchCode === SYSTEMS_BRANCH_CODE) return false;
  if (serviceTypes && serviceTypes.length > 0) {
    return serviceTypes.every((s) => s.serviceKind === "GUARDS" || s.serviceKind === "ALARMS");
  }
  return Boolean((enquiry?.guardsAmount > 0 || enquiry?.alarmsAmount > 0) && !enquiry?.otherServicesAmount);
};
